module.exports = __webpack_public_path__ + "static/corporates-bg-868c74700192d393e2dde0088a4f49ed.jpg";